import { COMPONENT_TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const swipe = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.SWIPE> =>
	createModel({
		type: COMPONENT_TYPE.SWIPE,
		editorProps: {
			expandable: true,
			expanded: true,
		},
		componentProps: {
			[UNIFORM_PROPS.onSwipe]: {
				left: '',
				right: '',
			},
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SWIPE>;
